/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { CustomerServiceLevel } from "./CustomerServiceLevel";
import {
  CustomerServiceLevelFromJSON,
  CustomerServiceLevelFromJSONTyped,
  CustomerServiceLevelToJSON,
  CustomerServiceLevelToJSONTyped,
} from "./CustomerServiceLevel";

/**
 *
 * @export
 * @interface CarrierShipmentReportConfig
 */
export interface CarrierShipmentReportConfig {
  /**
   *
   * @type {CurrencyCode}
   * @memberof CarrierShipmentReportConfig
   */
  currency: CurrencyCode;
  /**
   *
   * @type {number}
   * @memberof CarrierShipmentReportConfig
   */
  maxQuotePrice: number;
  /**
   *
   * @type {number}
   * @memberof CarrierShipmentReportConfig
   */
  lowestRateAdjustment: number;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  doNotCompareToCarrier: boolean;
  /**
   *
   * @type {string}
   * @memberof CarrierShipmentReportConfig
   */
  comparisonCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierShipmentReportConfig
   */
  comparisonServiceIdentifier?: string | null;
  /**
   *
   * @type {CustomerServiceLevel}
   * @memberof CarrierShipmentReportConfig
   */
  comparisonServiceLevel?: CustomerServiceLevel | null;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  breakoutCustomerSpecificRates: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  breakoutServiceTypes: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  breakoutServiceLevels: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  includeRankedNumber1: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  includeLowestRankCarrierIdentifier: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  skipWhenNoLowestRate: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  includeAdditionalCarrierColumns: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  includePickupDate: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierShipmentReportConfig
   */
  includeNmfc: boolean;
}

/**
 * Check if a given object implements the CarrierShipmentReportConfig interface.
 */
export function instanceOfCarrierShipmentReportConfig(
  value: object,
): value is CarrierShipmentReportConfig {
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("maxQuotePrice" in value) || value["maxQuotePrice"] === undefined)
    return false;
  if (
    !("lowestRateAdjustment" in value) ||
    value["lowestRateAdjustment"] === undefined
  )
    return false;
  if (
    !("doNotCompareToCarrier" in value) ||
    value["doNotCompareToCarrier"] === undefined
  )
    return false;
  if (
    !("breakoutCustomerSpecificRates" in value) ||
    value["breakoutCustomerSpecificRates"] === undefined
  )
    return false;
  if (
    !("breakoutServiceTypes" in value) ||
    value["breakoutServiceTypes"] === undefined
  )
    return false;
  if (
    !("breakoutServiceLevels" in value) ||
    value["breakoutServiceLevels"] === undefined
  )
    return false;
  if (
    !("includeRankedNumber1" in value) ||
    value["includeRankedNumber1"] === undefined
  )
    return false;
  if (
    !("includeLowestRankCarrierIdentifier" in value) ||
    value["includeLowestRankCarrierIdentifier"] === undefined
  )
    return false;
  if (
    !("skipWhenNoLowestRate" in value) ||
    value["skipWhenNoLowestRate"] === undefined
  )
    return false;
  if (
    !("includeAdditionalCarrierColumns" in value) ||
    value["includeAdditionalCarrierColumns"] === undefined
  )
    return false;
  if (
    !("includePickupDate" in value) ||
    value["includePickupDate"] === undefined
  )
    return false;
  if (!("includeNmfc" in value) || value["includeNmfc"] === undefined)
    return false;
  return true;
}

export function CarrierShipmentReportConfigFromJSON(
  json: any,
): CarrierShipmentReportConfig {
  return CarrierShipmentReportConfigFromJSONTyped(json, false);
}

export function CarrierShipmentReportConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierShipmentReportConfig {
  if (json == null) {
    return json;
  }
  return {
    currency: CurrencyCodeFromJSON(json["currency"]),
    maxQuotePrice: json["maxQuotePrice"],
    lowestRateAdjustment: json["lowestRateAdjustment"],
    doNotCompareToCarrier: json["doNotCompareToCarrier"],
    comparisonCarrierIdentifier:
      json["comparisonCarrierIdentifier"] == null
        ? undefined
        : json["comparisonCarrierIdentifier"],
    comparisonServiceIdentifier:
      json["comparisonServiceIdentifier"] == null
        ? undefined
        : json["comparisonServiceIdentifier"],
    comparisonServiceLevel:
      json["comparisonServiceLevel"] == null
        ? undefined
        : CustomerServiceLevelFromJSON(json["comparisonServiceLevel"]),
    breakoutCustomerSpecificRates: json["breakoutCustomerSpecificRates"],
    breakoutServiceTypes: json["breakoutServiceTypes"],
    breakoutServiceLevels: json["breakoutServiceLevels"],
    includeRankedNumber1: json["includeRankedNumber1"],
    includeLowestRankCarrierIdentifier:
      json["includeLowestRankCarrierIdentifier"],
    skipWhenNoLowestRate: json["skipWhenNoLowestRate"],
    includeAdditionalCarrierColumns: json["includeAdditionalCarrierColumns"],
    includePickupDate: json["includePickupDate"],
    includeNmfc: json["includeNmfc"],
  };
}

export function CarrierShipmentReportConfigToJSON(
  json: any,
): CarrierShipmentReportConfig {
  return CarrierShipmentReportConfigToJSONTyped(json, false);
}

export function CarrierShipmentReportConfigToJSONTyped(
  value?: CarrierShipmentReportConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    currency: CurrencyCodeToJSON(value["currency"]),
    maxQuotePrice: value["maxQuotePrice"],
    lowestRateAdjustment: value["lowestRateAdjustment"],
    doNotCompareToCarrier: value["doNotCompareToCarrier"],
    comparisonCarrierIdentifier: value["comparisonCarrierIdentifier"],
    comparisonServiceIdentifier: value["comparisonServiceIdentifier"],
    comparisonServiceLevel: CustomerServiceLevelToJSON(
      value["comparisonServiceLevel"],
    ),
    breakoutCustomerSpecificRates: value["breakoutCustomerSpecificRates"],
    breakoutServiceTypes: value["breakoutServiceTypes"],
    breakoutServiceLevels: value["breakoutServiceLevels"],
    includeRankedNumber1: value["includeRankedNumber1"],
    includeLowestRankCarrierIdentifier:
      value["includeLowestRankCarrierIdentifier"],
    skipWhenNoLowestRate: value["skipWhenNoLowestRate"],
    includeAdditionalCarrierColumns: value["includeAdditionalCarrierColumns"],
    includePickupDate: value["includePickupDate"],
    includeNmfc: value["includeNmfc"],
  };
}
